import React from "react";
import { getDisplayName } from "../../../utils/userDisplayName";

const VoterAvatars = ({ voters, maxDisplay = 5 }) => {
  const displayedVoters = voters.slice(0, maxDisplay);
  const remainingCount = voters.length - maxDisplay;

  return (
    <div className="tw-flex tw-items-center">
      <div className="tw-flex -tw-space-x-2">
        {displayedVoters.map((voter, index) => (
          <div
            key={index}
            className="tw-group tw-relative tw-h-8 tw-w-8 tw-overflow-hidden tw-rounded-full tw-border-2 tw-border-white"
          >
            <img
              src={voter.avatar_url}
              alt={getDisplayName(voter)}
              className="tw-h-full tw-w-full tw-object-cover"
            />
            <div className="tw-group-hover:tw-visible tw-invisible tw-absolute tw-bottom-full tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-2 tw-transform tw-whitespace-nowrap tw-rounded tw-bg-black tw-px-2 tw-py-1 tw-text-xs tw-text-white">
              {getDisplayName(voter)}
            </div>
          </div>
        ))}
        {remainingCount > 0 && (
          <div className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-white tw-bg-gray-100">
            <span className="tw-text-xs tw-font-medium tw-text-gray-600">+{remainingCount}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default VoterAvatars;
